import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import ConfirmPassword from "../pages/Authentication/ConfirmPassword"
// Dashboard
import Dashboard from "../pages/Dashboard/index"
import NewPassword from "pages/Authentication/NewPassword"
import TermsOfUse from "pages/Authentication/TermsOfUse"

const userRoutes = [
  { path: "/dashboard", component: Dashboard },

  // // //profile
  { path: "/profile", component: UserProfile },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const authRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
  { path: "/confirm-password", component: ConfirmPassword },
  { path: "/new-password", component: NewPassword },
  { path: "/terms-of-use", component: TermsOfUse },
]

export { userRoutes, authRoutes }
